import { render } from "./TicketList.vue?vue&type=template&id=a3b38540&scoped=true"
import script from "./TicketList.vue?vue&type=script&lang=js"
export * from "./TicketList.vue?vue&type=script&lang=js"

import "./TicketList.vue?vue&type=style&index=0&id=a3b38540&lang=scss&scoped=true"

import exportComponent from "/Users/ilss0902/PorjectCenter/Cloudmobile/雲端POS_V2/code/dayungs_pos_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3b38540"]])

export default __exports__